module.exports = __webpack_public_path__ + "img/esfp-selected.1dd5790a.png";